/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from './components/shared/navbar/navbar.component.ngfactory';
import * as i3 from '../../../src/app/components/shared/navbar/navbar.component';
import * as i4 from '../../../src/app/providers/auth.service';
import * as i5 from '@angular/router';
import * as i6 from './components/shared/cookiebar/cookiebar.component.ngfactory';
import * as i7 from '../../../src/app/components/shared/cookiebar/cookiebar.component';
import * as i8 from '../../../src/app/providers/cookie.service';
import * as i9 from '../../../src/app/app.component';
import * as i10 from '../../../src/app/providers/posthog.service';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),0,'span',[['defaultOverlayTarget',
      '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'hj-navbar',([] as any[]),(null as any),(null as any),(null as any),i2.View_NavbarComponent_0,
          i2.RenderType_NavbarComponent)),i1.ɵdid(245760,(null as any),0,i3.NavbarComponent,
          [i4.AuthService],(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵeld(16777216,(null as any),(null as any),1,'router-outlet',
          ([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(212992,(null as any),0,i5.RouterOutlet,[i5.ChildrenOutletContexts,i1.ViewContainerRef,
          i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],(null as any),
          (null as any)),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),1,'cookiebar',([] as any[]),(null as any),(null as any),
          (null as any),i6.View_CookiebarComponent_0,i6.RenderType_CookiebarComponent)),
      i1.ɵdid(114688,(null as any),0,i7.CookiebarComponent,[i5.Router,i8.CookieService],
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,
      _v) => {
    _ck(_v,3,0);
    _ck(_v,6,0);
    _ck(_v,9,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'hackajob-app',
      ([] as any[]),(null as any),(null as any),(null as any),View_AppComponent_0,
      RenderType_AppComponent)),i1.ɵdid(49152,(null as any),0,i9.AppComponent,[i10.PosthogService],
      (null as any),(null as any))],(null as any),(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i9.AppComponent> = i1.ɵccf('hackajob-app',
    i9.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9hcHAuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9ub2RlL2FwcC9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvbm9kZS9hcHAvc3JjL2FwcC9hcHAuY29tcG9uZW50LnRzLkFwcENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxzcGFuIGRlZmF1bHRPdmVybGF5VGFyZ2V0Pjwvc3Bhbj5cbjxoai1uYXZiYXI+PC9oai1uYXZiYXI+XG48cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG48Y29va2llYmFyPjwvY29va2llYmFyPlxuIiwiPGhhY2tham9iLWFwcD48L2hhY2tham9iLWFwcD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQWtDLHVDQUNsQztVQUFBO3VDQUFBLFVBQUE7VUFBQSw4Q0FBdUI7VUFBQSxTQUN2QjtVQUFBO2FBQUE7c0NBQUE7VUFBQSxlQUErQix1Q0FDL0I7VUFBQTtVQUFBO2FBQUE7VUFBQSw2QkFBdUI7O0lBRnZCO0lBQ0E7SUFDQTs7OztvQkNIQTtNQUFBOzZCQUFBLFVBQUE7TUFBQTs7OyJ9



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./compiled/src/app/app.component.ngfactory.ts